import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
export function ErrorPageBody(t0) {
  const $ = _c(8);
  const {
    statusCode,
    message
  } = t0;
  let t1;
  if ($[0] !== statusCode) {
    t1 = <h2 className="m-0 text-[8em] leading-[1em] font-normal opacity-20">{statusCode}</h2>;
    $[0] = statusCode;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== message) {
    t2 = <div className="mb-12 text-[2em] opacity-30">{message}</div>;
    $[2] = message;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Link href="/">🐸 → home page</Link>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2) {
    t4 = <div className="pt-6 text-center">{t1}{t2}{t3}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}